import { useTranslations } from 'next-intl'
import React from 'react'

import ZNoticeBanner from '@/_components/universal/z-notice-banner'
import { AMBULANCE_PRICE_LIST_TABLE_TYPE, IAmbulance, IPriceListItem } from '@/_types'

import {
	AAmbulancePriceListTableDefault,
	AAmbulancePriceListTableWithDefaultPriceForInsured,
	AAmbulancePriceListTableWithProgram
} from './a-ambulance-price-list-table'

interface IProps {
	ambulance: IAmbulance
	priceListItems: IPriceListItem[]
	/** Full ambulance price list — used for GA4 list `index` alignment with `view_item_list`. */
	allPriceListItems: IPriceListItem[]
}

export default function AAmbulancePriceList({
	ambulance,
	priceListItems,
	allPriceListItems
}: IProps) {
	const t = useTranslations('pages.ambulance_detail')

	if (!priceListItems.length) {
		return <div className='pdt-70lg pdt-130' />
	}

	return (
		<section id='cennik' className='pdt-30md pdt-70lg pdt-130 pdb-20md pdb-80lg pdb-120  price'>
			<div className='wrapper_full'>
				<div className='wrapper_amb wrapper_amb--big'>
					<div className='section_head mgl-0lg mgl-120'>
						<div className='anim_delay anim_drop1 observe'>
							<h2 className='title_h1 mgr-0lg mgr-40'>{t('priceList')}</h2>
						</div>
						<div className='dflex mgt-10lg mgt-20 justify-between align-start flex-dir-column-mdm'>
							<div className='page_content reset_margins text_s16 text_s14_lgm nobalance'>
								<p>{t('priceListDescription')}</p>
							</div>
						</div>
					</div>

					{/* <div className='mgl-0lg mgl-120 mt-8 bg-c13 px-14 py-8 rounded-xl text-center'>
						<div className='text_s16 text_s14_lgm nobalance'>
							<p>
								Niektoré služby je možné objednať{' '}
								<span className='font-medium'>iba prostredníctvom klientského centra</span>,
								telefonicky na čísle{' '}
								<a href='tel:+421220302303' className='underline'>
									02/20&nbsp;302&nbsp;303
								</a>{' '}
								alebo e-mailom na{' '}
								<a href='mailto:recepcia@medante.sk' className='underline'>
									recepcia@medante.sk
								</a>
								.
							</p>
						</div>
					</div> */}

					<ZNoticeBanner
						icon={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/legacy/icon-client-center.svg`}
						title={t('receptionOrderNotice.title')}
					>
						<p>
							{t('receptionOrderNotice.someServices')}{' '}
							<span className='font-medium'>
								{t('receptionOrderNotice.onlyThroughReception')}
							</span>
							, {t('receptionOrderNotice.throughPhone')}{' '}
							<a href='tel:+421220302303' className='!underline'>
								+421&nbsp;2&nbsp;20&nbsp;302&nbsp;303
							</a>{' '}
							{t('receptionOrderNotice.throughEmail')}{' '}
							<a href='mailto:recepcia@medante.sk' className='!underline'>
								recepcia@medante.sk
							</a>
							.
						</p>
					</ZNoticeBanner>

					{ambulance.priceListTableType === AMBULANCE_PRICE_LIST_TABLE_TYPE.DEFAULT && (
						<AAmbulancePriceListTableDefault
							ambulance={ambulance}
							priceListItems={priceListItems}
							allPriceListItems={allPriceListItems}
						/>
					)}
					{ambulance.priceListTableType ===
						AMBULANCE_PRICE_LIST_TABLE_TYPE.PLUS_WITH_AND_WITHOUT_YEAR_PROGRAM_PRICE && (
						<AAmbulancePriceListTableWithProgram
							ambulance={ambulance}
							priceListItems={priceListItems}
							allPriceListItems={allPriceListItems}
						/>
					)}
					{ambulance.priceListTableType ===
						AMBULANCE_PRICE_LIST_TABLE_TYPE.PLUS_DEFAULT_PRICE_FOR_INSURED && (
						<AAmbulancePriceListTableWithDefaultPriceForInsured
							ambulance={ambulance}
							priceListItems={priceListItems}
							allPriceListItems={allPriceListItems}
						/>
					)}
				</div>
			</div>
		</section>
	)
}
